export default __webpack_public_path__ + "static/media/PFDINTextPro-Medium.42348762.otf";